import Vue from "vue";
import Vuex from "vuex";

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";

import Auth from "./modules/Auth";
import Home from "./modules/Home";
import Users from "./modules/Users";
import Companies from "./modules/Companies";
import Registrations from "./modules/Registrations";
import Transporters from "./modules/Transporters";
import RegistrationsArchive from "./modules/RegistrationsArchive";
import RecurringRegistrations from "./modules/RecurringRegistrations";
import DriverOverview from "./modules/DriverOverview";
import Helpers from "./modules/Helpers";

Vue.use(Vuex);

// Create a new store
export default new Vuex.Store({
    actions,
    getters,
    mutations,
    state,
    modules: {
        Auth,
        Home,
        Users,
        Companies,
        Registrations,
        Transporters,
        RegistrationsArchive,
        RecurringRegistrations,
        DriverOverview,
        Helpers,
    },
});
